import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { config, type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faArrowUp,
  faCaretDown,
  faCaretRight,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faCompress,
  faCopy,
  faDesktop as faDesktopSolid,
  faDownload,
  faExpand,
  faEye,
  faLevelDown,
  faLocationDot,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faPhone,
  faPlus,
  faSort,
  faSortDown,
  faSortUp,
  faSquareCheck,
  faStar,
  faTrash,
  faTriangleExclamation,
  faTv,
  faXmark,
  faDollarSign,
  faArrowTrendUp
} from '@fortawesome/pro-solid-svg-icons';
import { faLinkedinIn, faSquareLinkedin } from '@fortawesome/free-brands-svg-icons';
import {
  faHexagonNodes as faHexagonNodesLight,
  faBuildings as faBuildingsLight,
  faMap as faMapLight,
  faCreditCard as faCreditCardLight,
  faEnvelope as faEnvelopeLight,
  faDatabase as faDatabaseLight,
  faDesktop as faDesktopLight,
  faFire as faFireLight,
  faBriefcaseArrowRight as faBriefcaseArrowRightLight,
  faMicrochip as faMicrochipLight,
  faNewspaper as faNewspaperLight,
  faPeopleGroup as faPeopleGroupLight,
  faSlidersSimple as faSlidersSimpleLight,
  faUpload as faUploadLight,
  faUserPlus as faUserPlusLight,
  faUsers as faUsersLight,
  faArrowTrendDown as faArrowTrendDownLight,
  faArrowTrendUp as faArrowTrendUpLight,
  faAward as faAwardLight,
  faHandHoldingCircleDollar as faHandHoldingCircleDollarLight,
  faBagShoppingPlus as faBagShoppingPlusLight,
  faBagShoppingMinus as faBagShoppingMinusLight,
  faBell as faBellLight,
  faBuildingCircleXmark as faBuildingCircleXmarkLight,
  faCircleExclamation as faCircleExclamationLight,
  faCircleMinus as faCircleMinusLight,
  faDiagramProject as faDiagramProjectLight,
  faGavel as faGavelLight,
  faHandshake as faHandshakeLight,
  faIdBadge as faIdBadgeLight,
  faMoneyBillWave as faMoneyBillWaveLight,
  faMoneyCheckDollar as faMoneyCheckDollarLight,
  faMerge as faMergeLight,
  faPen as faPenLight,
  faPresentationScreen as faPresentationScreenLight,
  faLandmarkFlag as faLandmarkFlagLight,
  faRightLeft as faRightLeftLight,
  faRocketLaunch as faRocketLaunchLight,
  faRotate as faRotateLight,
  faScaleBalanced as faScaleBalancedLight,
  faTriangleExclamation as faTriangleExclamationLight,
  faUserCircleMinus as faUserCircleMinusLight,
  faUserGroupCrown as faUserGroupCrownLight,
  faLightbulbExclamation as faLightbulbExclamationLight,
} from '@fortawesome/pro-light-svg-icons';
import { faFloppyDisk, faTrashCan, faWindowRestore, faSuitcase, faGlobe, faPhone as faPhoneRegular, faLocationDot as faLocationDotRegular, faText, faBarsSort, faAngleDown, faAngleRight, faLock } from '@fortawesome/pro-regular-svg-icons';
import { faPeopleGroup as faPeopleGroupSharpLight } from '@fortawesome/sharp-light-svg-icons';
import { faAiCustom } from '@awesome.me/kit-8c254da4b6/icons/kit/custom';
import { MATERIAL_ICON_TO_FONTAWESOME } from '../icons/material-icon-to-fontawesome-icon-map';

@Injectable({
  providedIn: 'root',
})
export class FontAwesomeIconRegistry {
  constructor(private readonly iconLibrary: FaIconLibrary) {}

  init(): void {
    // Prefer deterministic CSS (bundled in styles.scss), avoid runtime style injection.
    config.autoAddCss = false;

    this.iconLibrary.addIcons(
      faArrowRight,
      faArrowUp,
      faCheck,
      faXmark,
      faCaretDown,
      faCaretRight,
      faTriangleExclamation,
      faMagnifyingGlass,
      faMagnifyingGlassPlus,
      faStar,
      faEye,
      faCopy,
      faDownload,
      faPlus,
      faCompress,
      faExpand,
      faDesktopSolid,
      faPhone,
      faCircle,
      faCircleCheck,
      faCircleInfo,
      faCircleQuestion,
      faLocationDot,
      faLightbulbExclamationLight,
      faSquareCheck,
      faSort,
      faSortDown,
      faSortUp,
      faTrash,
      faTv,
      faLevelDown,
      faFloppyDisk,
      faTrashCan,
      faWindowRestore,
      faGlobe,
      faPhoneRegular,
      faLocationDotRegular,
      faText,
      faBarsSort,
      faAngleDown,
      faAngleRight,
      faLock,
      faChevronDown,
      faChevronUp,
      faLinkedinIn,
      faSquareLinkedin,
      faHexagonNodesLight,
      faBuildingsLight,
      faMapLight,
      faEnvelopeLight,
      faCreditCardLight,
      faDatabaseLight,
      faDesktopLight,
      faFireLight,
      faBriefcaseArrowRightLight,
      faMicrochipLight,
      faNewspaperLight,
      faPeopleGroupLight,
      faSlidersSimpleLight,
      faUploadLight,
      faUserPlusLight,
      faUsersLight,
      faArrowTrendDownLight,
      faArrowTrendUpLight,
      faAwardLight,
      faHandHoldingCircleDollarLight,
      faBagShoppingPlusLight,
      faBellLight,
      faBuildingCircleXmarkLight,
      faCircleExclamationLight,
      faCircleMinusLight,
      faDiagramProjectLight,
      faGavelLight,
      faHandshakeLight,
      faIdBadgeLight,
      faMoneyBillWaveLight,
      faMoneyCheckDollarLight,
      faMergeLight,
      faPenLight,
      faBagShoppingMinusLight,
      faPresentationScreenLight,
      faLandmarkFlagLight,
      faRightLeftLight,
      faRocketLaunchLight,
      faRotateLight,
      faScaleBalancedLight,
      faTriangleExclamationLight,
      faUserCircleMinusLight,
      faUserGroupCrownLight,
      faPeopleGroupSharpLight,
      faAiCustom,
      faDollarSign,
      faArrowTrendUp,
      faSuitcase
    );

    // Register all icons from the canonical Material icon -> Font Awesome mapping.
    // After finalization, templates bind IconProp tuples (e.g. `['fal','magnifying-glass']`)
    // which must resolve via the FaIconLibrary.
    this.iconLibrary.addIcons(...this.getMaterialIconMappingIcons());
  }

  private getMaterialIconMappingIcons(): IconDefinition[] {
    const uniqueIcons = new Map<string, IconDefinition>();
    for (const mapping of Object.values(MATERIAL_ICON_TO_FONTAWESOME)) {
      const icon = mapping.previewIcon;
      uniqueIcons.set(`${icon.prefix}:${icon.iconName}`, icon);
    }
    return [...uniqueIcons.values()];
  }
}

